(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const wetTimers = new WeakMap();

  const ensureWetVideo = (surface) => {
    const existing = surface.querySelector('.siwa-paper__wet-video');
    if (existing) return existing;
    const source = document.body.dataset.siwaPaperWetSrc;
    if (!source) return null;

    const effect = document.createElement('span');
    effect.className = 'siwa-paper__wet-effect';
    effect.setAttribute('aria-hidden', 'true');
    const video = document.createElement('video');
    video.className = 'siwa-paper__wet-video';
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.src = source;
    effect.append(video);
    surface.prepend(effect);
    return video;
  };

  const stopWetting = (surface) => {
    window.clearTimeout(wetTimers.get(surface));
    wetTimers.delete(surface);
    surface.classList.remove('is-wetting');
    const video = surface.querySelector('.siwa-paper__wet-video');
    if (!video) return;
    video.pause();
    video.loop = false;
    try {
      video.currentTime = 0;
    } catch (error) {
      // Leave the resting frame in place if the browser cannot seek yet.
    }
  };

  const startWetting = (surface, duration = 1250, loop = false) => {
    const video = ensureWetVideo(surface);
    window.clearTimeout(wetTimers.get(surface));
    surface.classList.remove('is-wetting');
    void surface.offsetWidth;
    surface.classList.add('is-wetting');

    if (video) {
      video.pause();
      video.playbackRate = 2.6;
      video.loop = loop;
      try {
        video.currentTime = 0;
      } catch (error) {
        // Metadata can still be loading on the first interaction.
      }
      video.play().catch(() => {});
    }

    if (duration > 0) wetTimers.set(surface, window.setTimeout(() => stopWetting(surface), duration));
  };

  const monitorPaperAction = (button) => {
    button.classList.add('is-paper-loading');
    if (!reducedMotion.matches) startWetting(button, 0, true);

    const started = window.performance.now();
    let sawLoadingLabel = false;
    const monitor = window.setInterval(() => {
      const elapsed = window.performance.now() - started;
      const label = button.textContent.trim().toLowerCase();
      const loading = button.classList.contains('is-loading') || label === 'adding' || label.startsWith('adding ');
      if (loading) sawLoadingLabel = true;
      const complete = sawLoadingLabel ? !loading && elapsed > 180 : elapsed > 600;
      if (!complete && elapsed < 10000) return;
      window.clearInterval(monitor);
      button.classList.remove('is-paper-loading');
      stopWetting(button);
    }, 80);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-siwa-paper-wet-button]');
    if (!button || button.disabled) return;
    monitorPaperAction(button);
  });

  document.addEventListener('submit', (event) => {
    const button = event.submitter?.closest?.('[data-siwa-paper-checkout], [data-siwa-paper-submit-transition]');
    const form = event.target;
    if (!button || form.dataset.siwaPaperCheckoutReady === 'true' || reducedMotion.matches) return;

    event.preventDefault();
    form.dataset.siwaPaperCheckoutReady = 'true';
    button.classList.add('is-paper-loading');
    button.disabled = true;
    startWetting(button, 1250);
    window.setTimeout(() => {
      button.disabled = false;
      form.requestSubmit(button);
    }, 1250);
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-siwa-paper-link]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target.toLowerCase() !== '_self') return;
    if (link.hasAttribute('download') || link.classList.contains('is-wetting')) return;

    const destination = link.href;
    if (!destination || reducedMotion.matches) return;

    const current = new URL(window.location.href);
    const next = new URL(destination, current);
    if (next.origin === current.origin && next.pathname === current.pathname && next.search === current.search && next.hash) return;

    event.preventDefault();
    const duration = Number.parseInt(link.dataset.siwaPaperDuration, 10) || 1250;
    link.setAttribute('aria-busy', 'true');
    startWetting(link, duration);

    window.setTimeout(() => window.location.assign(destination), duration);
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.siwa-paper.is-wetting, .siwa-paper.is-paper-loading').forEach((surface) => {
      stopWetting(surface);
      surface.classList.remove('is-paper-loading');
      surface.removeAttribute('aria-busy');
    });
  });
})();
